import { render, staticRenderFns } from "./fenghui.vue?vue&type=template&id=78e75a1d&scoped=true&"
import script from "./fenghui.vue?vue&type=script&lang=js&"
export * from "./fenghui.vue?vue&type=script&lang=js&"
import style0 from "./fenghui.vue?vue&type=style&index=0&id=78e75a1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e75a1d",
  null
  
)

export default component.exports